import { Activity, LayoutDashboard, ListChecks, MoreHorizontal, ScrollText, Shield, Users } from "lucide-react";
import { NavLink, useLocation } from "react-router";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import { NavItems } from "./Sidebar";
import { useShellData } from "./shellData";

export function MobileDrawer({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-72 bg-sidebar p-2">
        <SheetHeader>
          <SheetTitle>ATATUS Test Suite</SheetTitle>
        </SheetHeader>
        <nav aria-label="Main" className="h-full overflow-auto">
          <NavItems collapsed={false} onNavigate={() => onOpenChange(false)} />
        </nav>
      </SheetContent>
    </Sheet>
  );
}

export function BottomTabBar({ onMore }: { onMore: () => void }) {
  const { pathname } = useLocation();
  const { user, pendingCount } = useShellData();
  const admin = pathname.startsWith("/admin") && user?.role === "ADMIN";
  const tabs = admin
    ? [
        { to: "/admin", label: "Admin", icon: Shield, end: true },
        { to: "/admin/users", label: "Users", icon: Users, badge: pendingCount },
        { to: "/admin/audit", label: "Audit", icon: ScrollText },
      ]
    : [
        { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
        { to: "/runs", label: "Runs", icon: Activity },
        { to: "/catalog", label: "Catalog", icon: ListChecks },
      ];
  return (
    <nav
      aria-label="Tabs"
      className="fixed inset-x-0 bottom-0 z-30 grid h-14 grid-cols-4 border-t bg-background pb-[env(safe-area-inset-bottom)] md:hidden no-print"
    >
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            cn(
              "relative flex min-h-11 flex-col items-center justify-center gap-0.5 text-xs",
              isActive ? "text-signal-text" : "text-muted-foreground",
            )
          }
        >
          <t.icon aria-hidden className="size-5" />
          {t.label}
          {"badge" in t && t.badge ? (
            <span className="absolute right-[30%] top-1.5 rounded-full bg-tone-amber-fg px-1 text-[10px] text-background">{t.badge}</span>
          ) : null}
        </NavLink>
      ))}
      <button
        type="button"
        onClick={onMore}
        className="flex min-h-11 flex-col items-center justify-center gap-0.5 text-xs text-muted-foreground"
        aria-label="More"
      >
        <MoreHorizontal aria-hidden className="size-5" />
        More
      </button>
    </nav>
  );
}
